/* PhenixPC Configurator - moteur client
   Mode guide (generation automatique + trois niveaux par poste), mode expert
   (comparateur, permutation rapide, filtres cumulables), indicateurs de vente
   (FPS estimes, bruit, evolutivite), devis numerote, panier groupe.
   ES5 strict : Chrome, Edge, Opera, Opera GX, Firefox, Safari. */
(function () {
  'use strict';

  var EUR = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  var money = function (c) { return EUR.format((c || 0) / 100); };
  var signed = function (c) { return (c > 0 ? '+ ' : c < 0 ? '- ' : '') + EUR.format(Math.abs(c) / 100); };

  var UNIVERS = {
    gaming: {
      nom: 'PC Gaming', budget: 900,
      texte: 'Hautes performances en jeu, evolutivite et refroidissement soigne. Du 1080p competitif au 4K.',
      fourchette: 'a partir de 900 EUR',
      questions: [
        { k: 'jeux', l: 'Quels jeux principalement ?', o: [['esport', 'Competitif / e-sport'], ['aaa', 'AAA solo, beaux graphismes'], ['simu', 'Simulation, VR, simracing']] },
        { k: 'reso', l: 'Quelle resolution et quel rafraichissement ?', o: [['1080', '1080p 144 Hz'], ['1440', '1440p 165 Hz'], ['4k', '4K 120 Hz']] },
        { k: 'stream', l: 'Streamez ou enregistrez-vous vos parties ?', o: [['non', 'Non'], ['oui', 'Oui, regulierement']] }
      ]
    },
    bureautique: {
      nom: 'PC Bureautique', budget: 550,
      texte: 'Fiabilite, silence et cout maitrise. Pour la bureautique, la navigation et les logiciels metier.',
      fourchette: 'a partir de 450 EUR',
      questions: [
        { k: 'usage', l: 'Quel usage principal ?', o: [['bureau', 'Bureautique et navigation'], ['metier', 'Logiciel metier / comptabilite'], ['poly', 'Polyvalent famille']] },
        { k: 'ecrans', l: 'Combien d ecrans ?', o: [['1', 'Un ecran'], ['2', 'Deux ecrans'], ['3', 'Trois ou plus']] },
        { k: 'taille', l: 'Contrainte de place ou de silence ?', o: [['non', 'Aucune'], ['compact', 'Format compact souhaite'], ['silence', 'Silence prioritaire']] }
      ]
    },
    creation: {
      nom: 'PC Creation / Pro', budget: 1300,
      texte: 'Stabilite en charge longue, nombre de coeurs, memoire et stockage. Montage, 3D, CAO, M.A.O, photo.',
      fourchette: 'a partir de 1 200 EUR',
      questions: [
        { k: 'activite', l: 'Quelle activite ?', o: [['video', 'Montage video'], ['3d', '3D / rendu'], ['cao', 'CAO / DAO'], ['mao', 'M.A.O / audio']] },
        { k: 'reso', l: 'Quelle resolution de travail ?', o: [['1080', '1080p'], ['4k', '4K'], ['8k', '6K / 8K']] },
        { k: 'stock', l: 'Volume de projets a stocker ?', o: [['1', 'Moins de 1 To'], ['2', '1 a 4 To'], ['4', 'Plus de 4 To']] }
      ]
    }
  };

  var POIDS = {
    gaming:      { cpu: .17, mb: .09, ram: .07, gpu: .37, ssd: .09, cooling: .06, psu: .08, case: .07 },
    bureautique: { cpu: .26, mb: .14, ram: .12, gpu: 0,   ssd: .18, cooling: .08, psu: .11, case: .11 },
    creation:    { cpu: .25, mb: .11, ram: .15, gpu: .22, ssd: .12, cooling: .06, psu: .05, case: .04 }
  };
  var ORDRE_AUTO = ['cpu', 'mb', 'ram', 'gpu', 'ssd', 'cooling', 'psu', 'case'];
  var NIVEAUX = [
    { id: 'eco',  nom: 'Essentiel',   coef: .75, texte: 'Le meilleur rapport prix pour l usage decrit.' },
    { id: 'reco', nom: 'Conseille',   coef: 1,   texte: 'Notre equilibre de reference, celui que nous montons le plus.' },
    { id: 'perf', nom: 'Performance', coef: 1.4, texte: 'Marge confortable et evolutivite pour durer plus longtemps.' }
  ];

  var LIB = {
    socket: 'Socket', mem_type: 'Memoire', tdp_w: 'Consommation', perf_score: 'Indice perf.',
    capacite_go: 'Capacite', nb_modules: 'Barrettes', frequence_mhz: 'Frequence', hauteur_mm: 'Hauteur',
    longueur_mm: 'Longueur', vram_go: 'VRAM', puissance_w: 'Puissance', certification: 'Certification',
    format_alim: 'Format', type_refroid: 'Type', tdp_dissipe_w: 'Dissipation', radiateur_mm: 'Radiateur',
    gpu_max_mm: 'GPU max', ventirad_max_mm: 'Ventirad max', interface_stockage: 'Interface',
    chipset: 'Chipset', format_cm: 'Format', wifi_integre: 'Wi-Fi', rgb: 'RGB',
    formats_cm_acceptes: 'Formats acceptes', formats_alim_acceptes: 'Formats alim.',
    emplacements_radiateur: 'Emplacements radiateur', slots_ram: 'Slots RAM', slots_m2: 'Slots M.2',
    ports_sata: 'Ports SATA', emplacements_ventilo: 'Emplacements ventilos',
    pcie_8pin: 'PCIe 8 broches', pcie_12vhpwr: '12VHPWR', sockets_supportes: 'Sockets', delai_appro: 'Delai'
  };
  var UNITS = {
    tdp_w: ' W', hauteur_mm: ' mm', longueur_mm: ' mm', radiateur_mm: ' mm', gpu_max_mm: ' mm',
    ventirad_max_mm: ' mm', puissance_w: ' W', tdp_dissipe_w: ' W', frequence_mhz: ' MHz', vram_go: ' Go'
  };

  function fmtAttr(k, v) {
    if (v === true) return 'oui';
    if (v === false) return 'non';
    if (Array.isArray(v)) return v.join(' / ');
    if (k === 'capacite_go') return v >= 1000 ? (v / 1000) + ' To' : v + ' Go';
    return v + (UNITS[k] || '');
  }

  var DATA = { familles: [], regles: [], options: [], presets: [], parametres: {}, produits: [] };
  var byFam = {};

  function loadAll(root, done, fail) {
    var base = root.dataset.dataUrl, pages = [];
    function page(n) {
      fetch(base + (base.indexOf('?') > -1 ? '&' : '?') + 'page=' + n)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (t) {
          var j = JSON.parse(t.trim());
          pages.push(j);
          if (n === 1) {
            DATA.familles = j.familles || []; DATA.regles = j.regles || [];
            DATA.options = j.options || []; DATA.presets = j.presets || [];
            DATA.parametres = j.parametres || {};
          }
          if (n < (j.pages || 1) && n < 20) return page(n + 1);
          pages.forEach(function (p) { DATA.produits = DATA.produits.concat(p.produits || []); });
          DATA.familles.sort(function (a, b) { return a.ordre - b.ordre; });
          DATA.produits.forEach(function (p) {
            if (!byFam[p.fam]) byFam[p.fam] = [];
            byFam[p.fam].push(p);
          });
          Object.keys(byFam).forEach(function (f) {
            byFam[f].sort(function (a, b) { return a.prix - b.prix; });
          });
          done();
        })
        .catch(fail);
    }
    page(1);
  }

  var S = { univers: null, mode: 'avance', step: 0, vue: 'postes', profil: {}, budget: null,
            sel: {}, opts: {}, nom: '', propos: null, ref: null };

  function items(f) { return S.sel[f] || []; }
  function prod(vid) {
    for (var i = 0; i < DATA.produits.length; i++) if (DATA.produits[i].vid === vid) return DATA.produits[i];
    return null;
  }
  function chosen(f) { return items(f).map(function (l) { return { p: prod(l.vid), qty: l.qty }; }).filter(function (x) { return x.p; }); }
  function first(f) { var c = chosen(f); return c.length ? c[0].p : null; }
  function fam(code) { for (var i = 0; i < DATA.familles.length; i++) if (DATA.familles[i].code === code) return DATA.familles[i]; return null; }
  function attr(p, k) { return p && p.attrs ? p.attrs[k] : undefined; }
  function num(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }

  function puissance() {
    var P = DATA.parametres, w = 0;
    var cpu = first('cpu'); if (cpu) w += num(attr(cpu, 'tdp_w')) || 0;
    var gpu = first('gpu'); if (gpu) w += num(attr(gpu, 'tdp_w')) || 0;
    chosen('ram').forEach(function (x) { w += (num(attr(x.p, 'nb_modules')) || 1) * x.qty * (P.w_par_barrette || 10); });
    chosen('ssd').forEach(function (x) {
      var nvme = attr(x.p, 'interface_stockage') === 'M.2 NVMe';
      w += x.qty * (nvme ? (P.w_par_nvme || 8) : (P.w_par_sata || 12));
    });
    chosen('hdd').forEach(function (x) { w += x.qty * (P.w_par_sata || 12); });
    chosen('fan').forEach(function (x) { w += x.qty * (P.w_par_ventilateur || 3); });
    var cool = first('cooling');
    if (cool && String(attr(cool, 'type_refroid') || '').indexOf('AIO') === 0) w += (P.w_pompe_aio || 25);
    w += (P.w_carte_mere || 40);
    return Math.round(w * (num(P.coef_securite_alim) || 1.35));
  }

  function evaluate(candFam, cand, mode) {
    var backup, had = false;
    if (cand) {
      had = Object.prototype.hasOwnProperty.call(S.sel, candFam);
      backup = S.sel[candFam];
      var line = { vid: cand.vid, qty: 1 };
      S.sel[candFam] = (mode === 'add' && had && backup) ? backup.concat([line]) : [line];
    }
    var out = [];
    DATA.regles.forEach(function (r) { var d = check(r); if (d) out.push(d); });
    if (cand) { if (had) S.sel[candFam] = backup; else delete S.sel[candFam]; }
    return out;
  }

  function diag(r, va, vb, a, b) {
    var msg = (r.message || r.libelle || '')
      .replace(/\{va\}/g, va === null || va === undefined ? '?' : va)
      .replace(/\{vb\}/g, vb === null || vb === undefined ? '?' : vb)
      .replace(/\{a\}/g, a || '').replace(/\{b\}/g, b || '');
    return { code: r.code, severite: r.severite || 'information', message: msg, familles: [r.famille_a, r.famille_b] };
  }

  var PAR_ITEM = ['egal', 'inclus_dans', 'inferieur_ou_egal', 'implique', 'superieur_valeur', 'conflit_hauteur_ram', 'ecart_max'];

  function check(r) {
    if (PAR_ITEM.indexOf(r.operateur) === -1) return checkOne(r);
    var as = r.famille_a ? chosen(r.famille_a).map(function (x) { return x.p; }) : [];
    var bs = r.famille_b ? chosen(r.famille_b).map(function (x) { return x.p; }) : [];
    if (!as.length) as = [null];
    if (!bs.length) bs = [null];
    for (var i = 0; i < as.length; i++) for (var j = 0; j < bs.length; j++) {
      var d = checkOne(r, as[i], bs[j]);
      if (d) return d;
    }
    return null;
  }

  function checkOne(r, ovA, ovB) {
    var op = r.operateur, A = r.famille_a, B = r.famille_b;
    var pa = ovA !== undefined ? ovA : (A ? first(A) : null);
    var pb = ovB !== undefined ? ovB : (B ? first(B) : null);

    if (op === 'egal') {
      if (!pa || !pb) return null;
      var x = attr(pa, r.attribut_a), y = attr(pb, r.attribut_b);
      if (x === undefined || y === undefined) return null;
      return String(x) !== String(y) ? diag(r, x, y, pa.titre, pb.titre) : null;
    }
    if (op === 'inclus_dans') {
      if (!pa || !pb) return null;
      var v = attr(pa, r.attribut_a), lst = attr(pb, r.attribut_b);
      if (v === undefined || !Array.isArray(lst)) return null;
      return lst.some(function (e) { return String(e) === String(v); }) ? null : diag(r, v, lst.join(' / '), pa.titre, pb.titre);
    }
    if (op === 'inferieur_ou_egal') {
      if (!pa || !pb) return null;
      var na = num(attr(pa, r.attribut_a)), nb = num(attr(pb, r.attribut_b));
      if (na === null || nb === null) return null;
      return na > nb ? diag(r, na, nb, pa.titre, pb.titre) : null;
    }
    if (op === 'somme_inferieur_ou_egal') {
      if (!pb) return null;
      var lim = num(attr(pb, r.attribut_b)); if (lim === null) return null;
      var s = 0, any = false;
      chosen(A).forEach(function (it) { var u = num(attr(it.p, r.attribut_a)); if (u !== null) { s += u * it.qty; any = true; } });
      return any && s > lim ? diag(r, s, lim, '', pb.titre) : null;
    }
    if (op === 'qte_max') {
      if (!pb) return null;
      var l2 = num(attr(pb, r.attribut_b)); if (l2 === null) return null;
      var q = chosen(A).reduce(function (t, it) { return t + it.qty; }, 0);
      return q > l2 ? diag(r, q, l2, '', pb.titre) : null;
    }
    if (op === 'qte_max_si') {
      if (!pb) return null;
      var l3 = num(attr(pb, r.attribut_b)); if (l3 === null) return null;
      var cond = String(r.attribut_a || ''), neg = cond.indexOf('!=') > -1;
      var parts = cond.split(neg ? '!=' : '=');
      var key = (parts[0] || '').trim(), val = (parts[1] || '').trim(), q2 = 0;
      String(A || '').split('+').forEach(function (f) {
        chosen(f.trim()).forEach(function (it) {
          var av = attr(it.p, key); av = String(av === undefined ? '' : av);
          if (neg ? av !== val : av === val) q2 += it.qty;
        });
      });
      return q2 > l3 ? diag(r, q2, l3, '', pb.titre) : null;
    }
    if (op === 'puissance_alim') {
      if (!pb) return null;
      var need = puissance(), have = num(attr(pb, r.attribut_b));
      if (have === null) return null;
      return need > have ? diag(r, need, have, '', pb.titre) : null;
    }
    if (op === 'marge_alim_min') {
      if (!pb) return null;
      var n2 = puissance(), h2 = num(attr(pb, 'puissance_w'));
      if (!h2 || !n2) return null;
      var marge = Math.round((h2 - n2) / h2 * 100), seuil = num(r.valeur) || 15;
      return (marge >= 0 && marge < seuil) ? diag(r, marge, seuil, '', pb.titre) : null;
    }
    if (op === 'implique') {
      if (!pa || !pb) return null;
      if (attr(pa, r.attribut_a) !== true) return null;
      return attr(pb, r.attribut_b) === true ? null : diag(r, 'oui', 'non', pa.titre, pb.titre);
    }
    if (op === 'requis_si_faux') {
      if (!pa) return null;
      if (attr(pa, r.attribut_a) !== false) return null;
      return chosen(B).length === 0 ? diag(r, '', '', pa.titre, '') : null;
    }
    if (op === 'requis') { return chosen(A).length === 0 ? diag(r, '', '', '', '') : null; }
    if (op === 'ecart_max') {
      if (!pa || !pb) return null;
      var sa = num(attr(pa, r.attribut_a)), sb = num(attr(pb, r.attribut_b));
      if (sa === null || sb === null) return null;
      return Math.abs(sa - sb) > (num(r.valeur) || 30) ? diag(r, sa, sb, pa.titre, pb.titre) : null;
    }
    if (op === 'superieur_valeur') {
      if (!pa) return null;
      var v2 = num(attr(pa, r.attribut_a)), s2 = num(r.valeur);
      if (v2 === null || s2 === null) return null;
      return v2 > s2 ? diag(r, v2, s2, pa.titre, '') : null;
    }
    if (op === 'conflit_hauteur_ram') {
      if (!pa || !pb) return null;
      if (String(attr(pb, 'type_refroid')) !== 'Air') return null;
      var h = num(attr(pa, 'hauteur_mm')), s3 = num(r.valeur) || 40;
      if (h === null) return null;
      return h > s3 ? diag(r, h, s3, pa.titre, pb.titre) : null;
    }
    if (op === 'suggestion_si_superieur') {
      if (!pa) return null;
      var v3 = num(attr(pa, r.attribut_a)), s4 = num(r.valeur);
      if (v3 === null || s4 === null || v3 <= s4) return null;
      return chosen(B).length === 0 ? diag(r, v3, s4, pa.titre, '') : null;
    }
    if (op === 'inutile_si_vrai') {
      if (!pa) return null;
      if (attr(pa, r.attribut_a) !== true) return null;
      return chosen(B).length > 0 ? diag(r, '', '', pa.titre, '') : null;
    }
    if (op === 'info_si_valeur_dans') {
      if (!pa) return null;
      var v4 = String(attr(pa, r.attribut_a) || '');
      var l4 = String(r.valeur || '').split(',').map(function (s) { return s.trim(); });
      return l4.indexOf(v4) > -1 ? diag(r, v4, '', pa.titre, '') : null;
    }
    return null;
  }

  function candidateBlockers(famCode, p, mode) {
    return evaluate(famCode, p, mode).filter(function (d) {
      return d.severite === 'bloquant' && d.familles.indexOf(famCode) > -1;
    });
  }
  function compatible(famCode, p) { return candidateBlockers(famCode, p).length === 0; }
  function compatibles(famCode) {
    return (byFam[famCode] || []).filter(function (p) { return compatible(famCode, p); });
  }

  function fps() {
    var gpu = first('gpu'), cpu = first('cpu');
    if (!gpu) return null;
    var g = num(attr(gpu, 'perf_score'));
    if (g === null) return null;
    var c = cpu ? num(attr(cpu, 'perf_score')) : null;
    var plafond = c === null ? Infinity : Math.round(c * 2.7);
    return {
      p1080: Math.min(plafond, Math.round(g * 2.2)),
      p1440: Math.min(plafond, Math.round(g * 1.55)),
      p4k:   Math.min(plafond, Math.round(g * 0.85))
    };
  }

  function bruit() {
    var db = 28;
    var cool = first('cooling');
    if (cool) {
      var t = String(attr(cool, 'type_refroid') || '');
      db += t === 'Air' ? 4 : (t.indexOf('AIO 360') === 0 || t.indexOf('AIO 420') === 0) ? 2 : 3;
      var diss = num(attr(cool, 'tdp_dissipe_w'));
      var cpu = first('cpu'), tdp = cpu ? num(attr(cpu, 'tdp_w')) : null;
      if (diss && tdp && tdp > diss * .85) db += 3;
    }
    var gpu = first('gpu'), gt = gpu ? num(attr(gpu, 'tdp_w')) : 0;
    db += Math.round((gt || 0) / 45);
    var nbFans = chosen('fan').reduce(function (t, x) { return t + x.qty; }, 0);
    db += nbFans * 1.2;
    var psu = first('psu'), cert = psu ? String(attr(psu, 'certification') || '') : '';
    if (cert.indexOf('Titanium') > -1) db -= 2;
    else if (cert.indexOf('Platinum') > -1) db -= 1.5;
    else if (cert.indexOf('Gold') > -1) db -= 1;
    else if (cert.indexOf('Bronze') > -1) db -= .2;
    else if (cert) db += 1;
    db = Math.max(24, Math.round(db));
    var lab = db <= 32 ? 'Silencieux' : db <= 38 ? 'Discret' : db <= 44 ? 'Audible en charge' : 'Sonore en charge';
    return { db: db, label: lab };
  }

  function evolutivite() {
    var score = 0, details = [];
    var psu = first('psu'), need = puissance(), have = psu ? num(attr(psu, 'puissance_w')) : null;
    if (have && need) {
      var m = Math.round((have - need) / have * 100);
      score += Math.max(0, Math.min(35, m));
      details.push(m + ' % de marge d alimentation');
    }
    var mb = first('mb');
    if (mb) {
      var slots = num(attr(mb, 'slots_ram')) || 0;
      var utilises = chosen('ram').reduce(function (t, x) { return t + (num(attr(x.p, 'nb_modules')) || 1) * x.qty; }, 0);
      var libres = Math.max(0, slots - utilises);
      score += Math.min(20, libres * 10);
      if (libres) details.push(libres + ' emplacement' + (libres > 1 ? 's' : '') + ' memoire libre' + (libres > 1 ? 's' : ''));
      var m2 = num(attr(mb, 'slots_m2')) || 0;
      var m2u = chosen('ssd').filter(function (x) { return attr(x.p, 'interface_stockage') === 'M.2 NVMe'; })
        .reduce(function (t, x) { return t + x.qty; }, 0);
      var m2l = Math.max(0, m2 - m2u);
      score += Math.min(16, m2l * 8);
      if (m2l) details.push(m2l + ' emplacement' + (m2l > 1 ? 's' : '') + ' M.2 libre' + (m2l > 1 ? 's' : ''));
    }
    var cs = first('case'), gpu = first('gpu');
    if (cs) {
      var maxL = num(attr(cs, 'gpu_max_mm')) || 0;
      var curL = gpu ? (num(attr(gpu, 'longueur_mm')) || 0) : 0;
      var jeu = Math.max(0, maxL - curL);
      score += Math.min(15, Math.round(jeu / 8));
      if (jeu > 20) details.push(jeu + ' mm de degagement pour une carte plus longue');
      var vent = num(attr(cs, 'emplacements_ventilo')) || 0;
      var vu = chosen('fan').reduce(function (t, x) { return t + x.qty; }, 0);
      score += Math.min(14, Math.max(0, vent - vu) * 2);
    }
    score = Math.max(0, Math.min(100, Math.round(score)));
    var lab = score >= 70 ? 'Tres evolutive' : score >= 45 ? 'Evolutive' : score >= 25 ? 'Peu evolutive' : 'Fermee';
    return { score: score, label: lab, details: details };
  }

  function refDevis() {
    if (!S.ref) {
      var d = new Date();
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      S.ref = 'PXC-' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '-'
        + (Date.now().toString(36) + Math.random().toString(36).slice(2)).slice(-4).toUpperCase();
    }
    return S.ref;
  }

  function renderIndicateurs() {
    var f = fps(), b = bruit(), e = evolutivite();
    var cells = '';
    if (f) {
      cells += '<div><div class="k">FPS estimes 1080p</div><div class="v">' + f.p1080 + '</div></div>'
            +  '<div><div class="k">1440p</div><div class="v">' + f.p1440 + '</div></div>'
            +  '<div><div class="k">4K</div><div class="v">' + f.p4k + '</div></div>';
    }
    cells += '<div><div class="k">Niveau sonore</div><div class="v">' + b.db + ' dB</div>'
          +  '<div class="pcc-meta" style="margin:2px 0 0">' + esc(b.label) + '</div></div>';
    cells += '<div><div class="k">Evolutivite</div><div class="v">' + e.score + ' / 100</div>'
          +  '<div class="pcc-meta" style="margin:2px 0 0">' + esc(e.label) + '</div></div>';
    return '<div class="pcc-tech">' + cells + '</div>'
      + (f ? '<p class="pcc-meta">Estimation en qualite elevee, calculee a partir des indices de performance. Les resultats reels varient selon le jeu et les reglages.</p>' : '');
  }

  function pickBest(famCode, plafond, viserPerf) {
    var list = compatibles(famCode);
    if (!list.length) return null;
    var dansBudget = list.filter(function (p) { return p.prix <= plafond; });
    var pool = dansBudget.length ? dansBudget : [list[0]];
    if (!viserPerf) return pool[0];
    var best = pool[0], bestScore = -1;
    pool.forEach(function (p) {
      var s = num(attr(p, 'perf_score'));
      if (s === null) s = p.prix / 1000;
      if (s > bestScore) { bestScore = s; best = p; }
    });
    return best;
  }

  function autoBuild(univers, budgetEuros, coef) {
    var sauve = S.sel;
    S.sel = {};
    var poids = POIDS[univers] || POIDS.gaming;
    var budget = Math.round(budgetEuros * 100 * coef);

    ORDRE_AUTO.forEach(function (f) {
      var part = poids[f];
      if (part === 0) return;
      if (!(byFam[f] || []).length) return;
      var plafond = Math.round(budget * (part || .08) * 1.35);
      var viser = (f !== 'psu' && f !== 'case' && f !== 'cooling');
      var p = pickBest(f, plafond, viser);
      if (p) S.sel[f] = [{ vid: p.vid, qty: 1 }];
    });

    for (var tour = 0; tour < 3; tour++) {
      var bloq = evaluate().filter(function (d) { return d.severite === 'bloquant'; });
      if (!bloq.length) break;
      var cible = null;
      bloq[0].familles.forEach(function (f) {
        if (!cible && f && (byFam[f] || []).length && ORDRE_AUTO.indexOf(f) > -1) cible = f;
      });
      if (!cible) break;
      var sauveCible = S.sel[cible];
      delete S.sel[cible];
      var repl = pickBest(cible, Infinity, false);
      if (repl) S.sel[cible] = [{ vid: repl.vid, qty: 1 }];
      else { S.sel[cible] = sauveCible; break; }
    }
    var res = S.sel;
    S.sel = sauve;
    return res;
  }

  function totalDe(sel) {
    var t = 0;
    Object.keys(sel).forEach(function (f) {
      sel[f].forEach(function (l) { var p = prod(l.vid); if (p) t += p.prix * l.qty; });
    });
    return t;
  }

  function genererPropositions() {
    var b = S.budget || (UNIVERS[S.univers] ? UNIVERS[S.univers].budget : 900);
    return NIVEAUX.map(function (n) {
      var sel = autoBuild(S.univers, b, n.coef);
      return { id: n.id, nom: n.nom, texte: n.texte, sel: sel, total: totalDe(sel) };
    });
  }

  function niveauxPoste(famCode) {
    var actuel = first(famCode);
    var list = compatibles(famCode);
    if (actuel && list.indexOf(actuel) === -1) list = list.concat([actuel]);
    if (!list.length) return [];
    list.sort(function (a, b) { return a.prix - b.prix; });
    var eco = list[0];
    var perf = list[0], bs = -1;
    list.forEach(function (p) {
      var s = num(attr(p, 'perf_score'));
      if (s === null) s = p.prix / 1000;
      if (s > bs) { bs = s; perf = p; }
    });
    var reco = actuel || list[Math.min(list.length - 1, Math.floor(list.length / 2))];
    var out = [], vus = {};
    [['eco', 'Essentiel', eco], ['reco', 'Conseille', reco], ['perf', 'Performance', perf]].forEach(function (n) {
      if (!n[2] || vus[n[2].vid]) return;
      vus[n[2].vid] = 1;
      out.push({ id: n[0], label: n[1], p: n[2] });
    });
    out.sort(function (a, b) { return a.p.prix - b.p.prix; });
    return out;
  }

  function totalComposants() {
    var t = 0;
    Object.keys(S.sel).forEach(function (f) { chosen(f).forEach(function (x) { t += x.p.prix * x.qty; }); });
    return t;
  }
  function totalOptions() {
    var t = 0;
    DATA.options.forEach(function (o) { if (S.opts[o.code] && o.variant_id) t += o.prix; });
    return t;
  }
  function total() { return totalComposants() + totalOptions(); }

  function delaiGlobal() {
    var ordre = ['24h', '3 jours', '7 jours', '15 jours', 'Sur commande'], max = -1;
    Object.keys(S.sel).forEach(function (f) {
      chosen(f).forEach(function (x) { var i = ordre.indexOf(attr(x.p, 'delai_appro')); if (i > max) max = i; });
    });
    return max < 0 ? null : ordre[max];
  }

  function complet() {
    var manque = [];
    DATA.familles.forEach(function (f) {
      if (f.obligatoire && f.code !== 'service' && chosen(f.code).length === 0) manque.push(f.libelle);
    });
    return manque;
  }

  function progression() {
    var req = 0, ok = 0;
    DATA.familles.forEach(function (f) {
      if (f.obligatoire && f.code !== 'service') { req++; if (chosen(f.code).length) ok++; }
    });
    return req ? Math.round(ok / req * 100) : 0;
  }

  var root, els = {};
  function esc(s) { return String(s === null || s === undefined ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  function render() {
    saveLocal();
    var steps = ['Votre usage', 'Votre configuration', 'Vos options', 'Votre validation'];
    var nav = '<ol class="pcc-steps">' + steps.map(function (s, i) {
      var n = i + 1, cls = [];
      if (S.step === n) cls.push('on');
      if (S.step > n) cls.push('done', 'clickable');
      return '<li class="' + cls.join(' ') + '" data-goto="' + n + '"><span class="n">' + n + '</span>' + s + '</li>';
    }).join('') + '</ol>';
    var body = '';
    if (S.step === 0) body = viewUnivers();
    else if (S.step === 1) body = viewUsage();
    else if (S.step === 2) body = (S.mode === 'simplifie' && S.vue === 'propositions') ? viewPropositions() : viewConfig();
    else if (S.step === 3) body = viewOptions();
    else if (S.step === 4) body = viewRecap();
    els.app.innerHTML = (S.step > 0 ? nav : '') + body;
    renderBar();
    bind();
  }

  function viewUnivers() {
    var cards = Object.keys(UNIVERS).map(function (k) {
      var u = UNIVERS[k];
      return '<div class="pcc-card"><h3>' + esc(u.nom) + '</h3><p>' + esc(u.texte) + '</p>'
        + '<div class="pcc-range">' + esc(u.fourchette) + '</div><div class="pcc-modes">'
        + (DATA.parametres.mode_simplifie_actif !== false ? '<button class="pcc-btn pcc-btn--sm" data-start="' + k + '" data-mode="simplifie">Guidez-moi</button>' : '')
        + (DATA.parametres.mode_avance_actif !== false ? '<button class="pcc-btn pcc-btn--soft pcc-btn--sm" data-start="' + k + '" data-mode="avance">Mode expert</button>' : '')
        + '</div></div>';
    }).join('');
    var reprise = localStorage.getItem('pcc_state')
      ? '<div class="pcc-poste" style="margin-top:20px"><div class="ic">&#8635;</div><div class="body"><div class="lbl">Reprendre ma configuration</div>'
        + '<div class="chosen">Une configuration en cours a ete trouvee sur cet appareil.</div></div>'
        + '<div class="act"><button class="pcc-btn pcc-btn--sm" data-resume="1">Reprendre</button>'
        + '<button class="pcc-btn pcc-btn--soft pcc-btn--sm" data-forget="1">Oublier</button></div></div>'
      : '';
    var pres = DATA.presets.length
      ? '<h2 style="margin:34px 0 12px;font-size:1.2rem">Nos configurations pretes a partir</h2><div class="pcc-presets">'
        + DATA.presets.map(function (p) {
          var tot = p.composants.reduce(function (t, vid) { var x = prod(vid); return t + (x ? x.prix : 0); }, 0);
          return '<div class="pcc-preset"><div class="lv">' + esc(p.niveau || p.univers) + '</div><h4>' + esc(p.nom) + '</h4>'
            + '<p>' + esc((p.argumentaire || '').slice(0, 220)) + '</p><div class="pp">' + money(tot) + '</div>'
            + '<button class="pcc-btn pcc-btn--sm" data-preset="' + esc(p.handle) + '">Personnaliser cette config</button></div>';
        }).join('') + '</div>'
      : '';
    return '<div class="pcc-cards">' + cards + '</div>' + reprise + pres;
  }

  function viewUsage() {
    var u = UNIVERS[S.univers];
    if (S.mode === 'avance') {
      return '<h2 style="font-size:1.3rem;margin:0 0 6px">' + esc(u.nom) + ' - mode expert</h2>'
        + '<p class="pcc-sub">Une indication facultative, puis vous accedez directement au choix des composants.</p>'
        + '<div class="pcc-name"><input type="number" id="pcc-budget" placeholder="Budget indicatif en euros (facultatif)" value="' + (S.budget || '') + '"></div>'
        + '<div class="pcc-final"><button class="pcc-btn" data-next="2">Choisir mes composants</button>'
        + '<button class="pcc-link" data-mode="simplifie">Je prefere etre guide</button></div>';
    }
    var qs = u.questions.map(function (q) {
      return '<div class="pcc-grp"><h4>' + esc(q.l) + '</h4>' + q.o.map(function (o) {
        var on = S.profil[q.k] === o[0];
        return '<label class="pcc-opt' + (on ? ' on' : '') + '"><input type="radio" name="q_' + q.k + '" value="' + o[0] + '"' + (on ? ' checked' : '') + '>'
          + '<div class="oi"><div class="on-t">' + esc(o[1]) + '</div></div></label>';
      }).join('') + '</div>';
    }).join('');
    return '<h2 style="font-size:1.3rem;margin:0 0 6px">' + esc(u.nom) + ' - on vous guide</h2>'
      + '<p class="pcc-sub">Trois questions, et nous composons trois machines completes et compatibles. Vous pourrez tout ajuster ensuite.</p>'
      + qs
      + '<div class="pcc-grp"><h4>Votre budget</h4><div class="pcc-name">'
      + '<input type="number" id="pcc-budget" placeholder="Budget en euros, hors montage" value="' + (S.budget || u.budget) + '"></div></div>'
      + '<div class="pcc-final"><button class="pcc-btn" data-generer="1">Composer mes configurations</button>'
      + '<button class="pcc-link" data-mode="avance">Les PC n ont aucun secret pour vous ? Mode expert</button></div>';
  }

  function resume(sel) {
    var out = [];
    ['cpu', 'gpu', 'ram', 'ssd'].forEach(function (f) {
      var l = sel[f]; if (!l || !l.length) return;
      var p = prod(l[0].vid); if (!p) return;
      out.push('<em>' + esc(p.titre.replace('[TEST] ', '')) + '</em>');
    });
    return out.join('');
  }

  function viewPropositions() {
    if (!S.propos) S.propos = genererPropositions();
    var cards = S.propos.map(function (c, i) {
      var ecart = S.budget ? c.total - S.budget * 100 : null;
      return '<div class="pcc-preset"><div class="lv">' + esc(c.nom) + '</div>'
        + '<h4>' + esc(UNIVERS[S.univers].nom) + ' ' + esc(c.nom) + '</h4>'
        + '<p>' + esc(c.texte) + '</p>'
        + '<div class="sp" style="display:flex;gap:6px;flex-wrap:wrap;font-size:.78rem;color:var(--txt-2)">' + resume(c.sel) + '</div>'
        + '<div class="pp">' + money(c.total) + '</div>'
        + (ecart !== null ? '<div class="pcc-meta" style="margin:0">' + (Math.abs(ecart) < 10000 ? 'Dans votre budget' : signed(ecart) + ' par rapport a votre budget') + '</div>' : '')
        + '<button class="pcc-btn pcc-btn--sm" data-propos="' + i + '">Partir sur cette base</button></div>';
    }).join('');
    return '<h2 style="font-size:1.3rem;margin:0 0 6px">Trois machines pour vous</h2>'
      + '<p class="pcc-sub">Composees automatiquement a partir de vos reponses. Compatibilite verifiee, alimentation dimensionnee. Choisissez une base : chaque poste restera modifiable.</p>'
      + '<div class="pcc-presets">' + cards + '</div>'
      + '<div class="pcc-final"><button class="pcc-link" data-goto="1">Modifier mes reponses</button>'
      + '<button class="pcc-link" data-mode="avance">Passer en mode expert</button></div>';
  }

  function visibleFamilles() {
    return DATA.familles.filter(function (f) {
      if (f.code === 'service' || f.code === 'peripheral') return false;
      if (S.mode === 'simplifie' && f.visible_simplifie === false) return false;
      return (byFam[f.code] || []).length > 0 || f.obligatoire;
    });
  }

  function posteSimple(f, diags) {
    var c = chosen(f.code);
    var bad = diags.some(function (d) { return d.severite === 'bloquant' && d.familles.indexOf(f.code) > -1; });
    var actuelPrix = c.length ? c[0].p.prix : 0;
    var choix = niveauxPoste(f.code).map(function (n) {
      var on = c.length && c[0].p.vid === n.p.vid;
      var delta = n.p.prix - actuelPrix;
      return '<button class="pcc-opt' + (on ? ' on' : '') + '" data-niveau="' + f.code + '|' + n.p.vid + '" style="width:100%;text-align:left">'
        + '<div class="oi"><div class="on-t">' + esc(n.label)
        + (on ? ' <span class="badge req">Selectionne</span>' : '') + '</div>'
        + '<div class="od">' + esc(n.p.titre.replace('[TEST] ', '')) + '</div></div>'
        + '<div class="op">' + (on || !c.length ? money(n.p.prix) : signed(delta)) + '</div></button>';
    }).join('');
    var nb = (byFam[f.code] || []).length;
    return '<div class="pcc-poste' + (c.length ? ' filled' : '') + (bad ? ' invalid' : '') + '" style="display:block">'
      + '<div class="lbl" style="margin-bottom:10px">' + esc(f.libelle)
      + (f.obligatoire ? ' <span class="badge req">Requis</span>' : ' <span class="badge">Option</span>')
      + '</div>'
      + (f.aide ? '<div class="pcc-helptext" style="margin:0 0 10px">' + esc(f.aide) + '</div>' : '')
      + (choix || '<div class="pcc-meta">Aucune reference compatible pour ce poste.</div>')
      + '<div class="pcc-final" style="margin-top:8px">'
      + '<button class="pcc-link" data-pick="' + esc(f.code) + '">Voir les ' + nb + ' references</button>'
      + (c.length && !f.obligatoire ? '<button class="pcc-link" data-clear="' + esc(f.code) + '">Retirer ce poste</button>' : '')
      + '</div></div>';
  }

  function posteAvance(f, diags) {
    var c = chosen(f.code);
    var bad = diags.some(function (d) { return d.severite === 'bloquant' && d.familles.indexOf(f.code) > -1; });
    var cls = 'pcc-poste' + (c.length ? ' filled' : '') + (bad ? ' invalid' : '');
    var body, prix = '', swapBtns = '';
    if (c.length) {
      var tot = 0;
      body = c.map(function (x) {
        tot += x.p.prix * x.qty;
        var sp = (f.attributs_affiches || []).map(function (k) {
          var v = attr(x.p, k); return v === undefined ? null : fmtAttr(k, v);
        }).filter(Boolean).join(' - ');
        return '<b>' + esc(x.p.titre) + '</b>' + (x.qty > 1 ? ' x' + x.qty : '') + (sp ? '<br>' + esc(sp) : '');
      }).join('<br>');
      prix = '<div class="pcc-meta" style="margin:6px 0 0;color:var(--txt);font-weight:800">' + money(tot) + '</div>';
      if (c.length === 1) {
        var liste = compatibles(f.code).sort(function (a, b) { return a.prix - b.prix; });
        var idx = -1;
        liste.forEach(function (p, i) { if (p.vid === c[0].p.vid) idx = i; });
        swapBtns = '<button class="pcc-btn pcc-btn--ghost pcc-btn--sm" data-swap="' + esc(f.code) + '|-1"'
          + (idx <= 0 ? ' disabled' : '') + ' title="Reference compatible moins chere">&#9664;</button>'
          + '<button class="pcc-btn pcc-btn--ghost pcc-btn--sm" data-swap="' + esc(f.code) + '|1"'
          + (idx < 0 || idx >= liste.length - 1 ? ' disabled' : '') + ' title="Reference compatible plus chere">&#9654;</button>';
      }
    } else { body = f.obligatoire ? 'A choisir' : 'Facultatif'; }
    var nb = (byFam[f.code] || []).length;
    return '<div class="' + cls + '"><div class="ic">' + (c.length ? '&#10003;' : f.ordre) + '</div>'
      + '<div class="body"><div class="lbl">' + esc(f.libelle)
      + (f.obligatoire ? ' <span class="badge req">Requis</span>' : ' <span class="badge">Option</span>')
      + '</div><div class="chosen">' + body + '</div>' + prix
      + (f.aide ? '<button class="pcc-help" data-help="' + esc(f.code) + '">A quoi ca sert ?</button><div class="pcc-helptext pcc-hide" id="help-' + esc(f.code) + '">' + esc(f.aide) + '</div>' : '')
      + '<div class="pcc-meta" style="margin:6px 0 0">' + nb + ' reference' + (nb > 1 ? 's' : '') + ' au catalogue</div>'
      + '</div><div class="act">' + swapBtns
      + '<button class="pcc-btn pcc-btn--sm' + (c.length ? ' pcc-btn--soft' : '') + '" data-pick="' + esc(f.code) + '">' + (c.length ? 'Modifier' : 'Choisir') + '</button>'
      + (c.length && (f.qte_max || 1) > 1 ? '<button class="pcc-btn pcc-btn--ghost pcc-btn--sm" data-add="' + esc(f.code) + '">+ Ajouter</button>' : '')
      + (c.length ? '<button class="pcc-btn pcc-btn--ghost pcc-btn--sm" data-clear="' + esc(f.code) + '">Retirer</button>' : '')
      + '</div></div>';
  }

  function viewConfig() {
    var diags = evaluate();
    var simple = S.mode === 'simplifie';
    var postes = visibleFamilles().map(function (f) {
      return simple ? posteSimple(f, diags) : posteAvance(f, diags);
    }).join('');
    return '<div class="pcc-layout"><div>' + renderDiags(diags) + postes
      + '<div class="pcc-final" style="margin-top:16px">'
      + '<button class="pcc-btn" data-next="3">Continuer vers les options</button>'
      + '<button class="pcc-link" data-reset="1">Tout supprimer</button>'
      + (simple ? '<button class="pcc-link" data-mode="avance">Passer en mode expert</button>'
                : '<button class="pcc-link" data-mode="simplifie">Revenir au mode guide</button>')
      + '</div></div>' + renderSummary() + '</div>';
  }

  function renderDiags(diags) {
    if (!diags.length) return '';
    var lab = { bloquant: 'Incompatibilite', avertissement: 'Point de vigilance', information: 'Information', suggestion: 'Conseil' };
    return '<ul class="pcc-diags">' + diags.map(function (d) {
      return '<li class="pcc-diag ' + d.severite + '"><b>' + lab[d.severite] + ' - ' + esc(d.code) + '</b>' + esc(d.message) + '</li>';
    }).join('') + '</ul>';
  }

  function renderSummary() {
    var lines = '';
    DATA.familles.forEach(function (f) {
      chosen(f.code).forEach(function (x) {
        lines += '<div class="pcc-sum-line"><span class="t">' + esc(f.libelle) + '<b>' + esc(x.p.titre) + '</b></span>'
          + '<span class="p">' + money(x.p.prix * x.qty) + '</span></div>';
      });
    });
    DATA.options.forEach(function (o) {
      if (S.opts[o.code] && o.variant_id) {
        lines += '<div class="pcc-sum-line"><span class="t">Option<b>' + esc(o.libelle) + '</b></span><span class="p">' + money(o.prix) + '</span></div>';
      }
    });
    if (!lines) lines = '<p class="pcc-meta">Aucun composant selectionne pour le moment.</p>';

    var pct = progression();
    var barre = '<div class="pcc-gauge"><div class="lab"><span>Avancement</span><span>' + pct + ' %</span></div>'
      + '<div class="bar"><div class="fill" style="width:' + pct + '%"></div></div></div>';

    var psu = first('psu'), need = puissance(), have = psu ? num(attr(psu, 'puissance_w')) : null;
    var gauge = '';
    if (need) {
      var p2 = have ? Math.min(100, Math.round(need / have * 100)) : 100;
      var marge = have ? Math.round((have - need) / have * 100) : -1;
      var cls = !have ? '' : marge >= (DATA.parametres.seuil_marge_verte || 25) ? '' : marge >= (DATA.parametres.seuil_marge_orange || 15) ? 'warn' : 'err';
      gauge = '<div class="pcc-gauge ' + cls + '"><div class="lab"><span>Puissance requise</span><span>' + need + ' W'
        + (have ? ' / ' + have + ' W' : '') + '</span></div><div class="bar"><div class="fill" style="width:' + p2 + '%"></div></div>'
        + (have ? '<div class="pcc-meta" style="margin-top:5px">Marge disponible : ' + marge + ' %</div>' : '<div class="pcc-meta" style="margin-top:5px">Aucune alimentation selectionnee.</div>')
        + '</div>';
    }

    var ind = '';
    if (totalComposants() > 0) {
      var b = bruit(), e = evolutivite(), f2 = fps();
      ind = '<div class="pcc-sum-line"><span class="t">Niveau sonore<b>' + b.db + ' dB - ' + esc(b.label) + '</b></span></div>'
        + '<div class="pcc-sum-line"><span class="t">Evolutivite<b>' + e.score + ' / 100 - ' + esc(e.label) + '</b></span></div>'
        + (f2 ? '<div class="pcc-sum-line"><span class="t">FPS estimes<b>' + f2.p1080 + ' en 1080p, ' + f2.p1440 + ' en 1440p</b></span></div>' : '');
    }

    var d = delaiGlobal(), manque = complet();
    var etat = manque.length
      ? '<div class="pcc-meta">Il reste a choisir : ' + esc(manque.join(', ')) + '</div>'
      : '<div class="pcc-meta" style="color:#25c26a">Configuration complete et compatible.</div>';
    var ecart = '';
    if (S.budget) {
      var diff = total() / 100 - S.budget;
      ecart = '<div class="pcc-meta">Budget annonce : ' + EUR.format(S.budget) + ' - ecart : ' + (diff >= 0 ? '+' : '') + EUR.format(diff) + '</div>';
    }
    return '<aside class="pcc-summary"><h3>Votre configuration</h3>' + lines + ind + barre + gauge
      + '<div class="pcc-total"><span>Total</span><strong>' + money(total()) + '</strong></div>'
      + (d ? '<div class="pcc-meta">Delai indicatif : ' + esc(d) + '</div>' : '') + ecart + etat
      + (S.step < 4 ? '<button class="pcc-btn pcc-btn--block" data-next="' + (S.step === 2 ? 3 : 4) + '">Continuer</button>' : '')
      + '<button class="pcc-btn pcc-btn--soft pcc-btn--block" data-share="1">Copier le lien de ma config</button>'
      + '</aside>';
  }

  function viewOptions() {
    var groupes = {};
    DATA.options.forEach(function (o) {
      var univ = o.univers;
      if (Array.isArray(univ) && univ.length && univ.indexOf(S.univers) === -1) return;
      var g = o.groupe || 'autres';
      (groupes[g] = groupes[g] || []).push(o);
    });
    var titres = { montage: 'Montage et tests', systeme: 'Systeme d exploitation', garantie: 'Garantie', esthetique: 'Personnalisation', performance: 'Performance', livraison: 'Livraison et retrait', peripheriques: 'Peripheriques et ecran', autres: 'Autres options' };
    var order = ['montage', 'systeme', 'garantie', 'performance', 'esthetique', 'livraison', 'peripheriques', 'autres'];
    var html = order.filter(function (g) { return groupes[g]; }).map(function (g) {
      return '<div class="pcc-grp"><h4>' + esc(titres[g] || g) + '</h4>' + groupes[g].map(function (o) {
        var on = !!S.opts[o.code] || o.obligatoire;
        return '<label class="pcc-opt' + (on ? ' on' : '') + (o.obligatoire ? ' lock' : '') + '">'
          + '<input type="checkbox" data-opt="' + esc(o.code) + '"' + (on ? ' checked' : '') + (o.obligatoire ? ' disabled' : '') + '>'
          + '<div class="oi"><div class="on-t">' + esc(o.libelle) + (o.obligatoire ? ' <span class="badge req">Inclus</span>' : '') + '</div>'
          + (o.description ? '<div class="od">' + esc(o.description) + '</div>' : '') + '</div>'
          + '<div class="op">' + money(o.prix) + '</div></label>';
      }).join('') + '</div>';
    }).join('');
    return '<div class="pcc-layout"><div><h2 style="font-size:1.3rem;margin:0 0 6px">Vos options et services</h2>'
      + '<p class="pcc-sub">Le montage est inclus : c est la contrepartie de notre garantie sur la machine complete.</p>'
      + html
      + '<div class="pcc-final"><button class="pcc-btn" data-next="4">Voir le recapitulatif</button>'
      + '<button class="pcc-link" data-next="2">Modifier ma configuration</button></div></div>'
      + renderSummary() + '</div>';
  }

  function viewRecap() {
    var diags = evaluate();
    var bloq = diags.filter(function (d) { return d.severite === 'bloquant'; });
    var manque = complet();
    var rowsC = '';
    DATA.familles.forEach(function (f) {
      chosen(f.code).forEach(function (x) {
        rowsC += '<tr><td class="q">' + x.qty + 'x</td><td><span class="rl">' + esc(f.libelle) + '</span><br>'
          + esc(x.p.marque) + ' - ' + esc(x.p.titre) + '</td><td class="p">' + money(x.p.prix * x.qty) + '</td></tr>';
      });
    });
    var rowsO = '';
    DATA.options.forEach(function (o) {
      if (S.opts[o.code] && o.variant_id) {
        rowsO += '<tr><td class="q">1x</td><td>' + esc(o.libelle) + '</td><td class="p">' + money(o.prix) + '</td></tr>';
      }
    });
    var cpu = first('cpu'), gpu = first('gpu');
    var nomDef = S.nom || ('PhenixPC ' + (UNIVERS[S.univers] ? UNIVERS[S.univers].nom.replace('PC ', '') : '')
      + (cpu ? ' - ' + cpu.titre.replace('[TEST] ', '') : '')
      + (gpu ? ' / ' + gpu.titre.replace('[TEST] ', '') : '')).slice(0, 90);
    var alerte = '';
    if (bloq.length) alerte = '<div class="pcc-err-box"><strong>Configuration non valide.</strong> ' + bloq.length + ' incompatibilite(s) a corriger avant la commande.</div>';
    else if (manque.length) alerte = '<div class="pcc-err-box"><strong>Configuration incomplete.</strong> Il reste a choisir : ' + esc(manque.join(', ')) + '.</div>';
    var d = delaiGlobal();
    var e = evolutivite();
    return '<div class="pcc-layout"><div>'
      + '<h2 style="font-size:1.3rem;margin:0 0 6px">Recapitulatif de votre configuration</h2>'
      + '<p class="pcc-sub">Devis <strong>' + esc(refDevis()) + '</strong> - valable 15 jours. Verifiez, nommez votre machine, puis ajoutez-la au panier.</p>'
      + alerte + renderDiags(diags)
      + '<div class="pcc-name"><input type="text" id="pcc-nom" maxlength="90" placeholder="Nommez votre configuration" value="' + esc(nomDef) + '"></div>'
      + '<div class="pcc-tech">'
      + '<div><div class="k">Puissance requise</div><div class="v">' + puissance() + ' W</div></div>'
      + '<div><div class="k">Delai indicatif</div><div class="v">' + esc(d || '-') + '</div></div>'
      + '<div><div class="k">Composants</div><div class="v">' + money(totalComposants()) + '</div></div>'
      + '<div><div class="k">Options</div><div class="v">' + money(totalOptions()) + '</div></div>'
      + '</div>'
      + '<h3 style="font-size:.74rem;text-transform:uppercase;letter-spacing:.14em;margin:26px 0 10px">Ce que vaut cette machine</h3>'
      + renderIndicateurs()
      + (e.details.length ? '<p class="pcc-meta">Marge d evolution : ' + esc(e.details.join(', ')) + '.</p>' : '')
      + '<div class="pcc-recap"><div class="pcc-recap-hd"><h4>Votre configuration</h4><button class="pcc-link" data-next="2">Modifier</button></div>'
      + '<table><tbody>' + (rowsC || '<tr><td colspan="3">Aucun composant.</td></tr>') + '</tbody></table></div>'
      + '<div class="pcc-recap"><div class="pcc-recap-hd"><h4>Vos options</h4><button class="pcc-link" data-next="3">Modifier</button></div>'
      + '<table><tbody>' + (rowsO || '<tr><td colspan="3">Aucune option.</td></tr>') + '</tbody></table></div>'
      + '<div class="pcc-final">'
      + '<button class="pcc-btn" data-cart="1"' + (bloq.length || manque.length ? ' disabled' : '') + '>Ajouter au panier - ' + money(total()) + '</button>'
      + '<button class="pcc-btn pcc-btn--soft" data-print="1">Imprimer le devis</button>'
      + '<button class="pcc-link" data-share="1">Copier le lien de partage</button>'
      + '</div>'
      + (total() / 100 >= (DATA.parametres.seuil_paiement_fractionne || 500) ? '<p class="pcc-meta" style="margin-top:12px">Paiement en plusieurs fois disponible sur cette configuration.</p>' : '')
      + '</div>' + renderSummary() + '</div>';
  }

  function renderBar() {
    if (!els.bar) return;
    if (S.step < 2) { els.bar.style.display = 'none'; return; }
    els.bar.style.display = '';
    els.bar.innerHTML = '<div class="bt">Total de la configuration<strong>' + money(total()) + '</strong></div>'
      + (S.step < 4 ? '<button class="pcc-btn pcc-btn--sm" data-next="' + Math.min(4, S.step + 1) + '">Continuer</button>' : '');
    els.bar.querySelectorAll('[data-next]').forEach(function (b) {
      b.onclick = function () { S.step = parseInt(b.dataset.next, 10); window.scrollTo({ top: 0, behavior: 'smooth' }); render(); };
    });
  }

  var pickFam = null, pickFilters = {}, pickSort = 'prix', pickQuery = '', pickAdd = false;
  var cmp = [], pickVue = 'liste';

  function openPicker(code, add) {
    pickFam = code; pickAdd = !!add; pickFilters = {}; pickQuery = ''; pickSort = 'prix';
    cmp = []; pickVue = 'liste';
    renderPicker();
    els.modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closePicker() { els.modal.hidden = true; pickFam = null; document.body.style.overflow = ''; }

  function comparaison() {
    var f = fam(pickFam);
    var prods = cmp.map(function (v) { return prod(v); }).filter(Boolean);
    if (!prods.length) return '<div class="pcc-empty">Aucune reference selectionnee.</div>';
    var cles = [];
    prods.forEach(function (p) {
      Object.keys(p.attrs || {}).forEach(function (k) { if (cles.indexOf(k) === -1) cles.push(k); });
    });
    var head = '<tr><td class="rl"></td>' + prods.map(function (p) {
      return '<td><span class="rl">' + esc(p.marque) + '</span><br><b>' + esc(p.titre) + '</b></td>';
    }).join('') + '</tr>';
    var prix = '<tr><td class="rl">Prix</td>' + prods.map(function (p) {
      return '<td class="p">' + money(p.prix) + '</td>';
    }).join('') + '</tr>';
    var lignes = cles.map(function (k) {
      return '<tr><td class="rl">' + esc(LIB[k] || k) + '</td>' + prods.map(function (p) {
        var v = attr(p, k);
        return '<td>' + (v === undefined ? '&mdash;' : esc(fmtAttr(k, v))) + '</td>';
      }).join('') + '</tr>';
    }).join('');
    var actions = '<tr><td></td>' + prods.map(function (p) {
      return '<td><button class="pcc-btn pcc-btn--sm" data-choose="' + p.vid + '">Choisir</button></td>';
    }).join('') + '</tr>';
    return '<div class="pcc-recap"><div class="pcc-recap-hd"><h4>Comparaison - ' + esc(f ? f.libelle : '') + '</h4>'
      + '<button class="pcc-link" data-vue="liste">Retour a la liste</button></div>'
      + '<table><tbody>' + head + prix + lignes + actions + '</tbody></table></div>';
  }

  function renderPicker() {
    var f = fam(pickFam); if (!f) return;

    if (pickVue === 'compare') {
      els.modal.innerHTML = '<div class="pcc-panel" role="dialog" aria-modal="true">'
        + '<div class="pcc-panel-hd"><div><h3>' + esc(f.libelle) + '</h3>'
        + '<p>Comparaison de ' + cmp.length + ' references</p></div>'
        + '<button class="pcc-close" data-close="1" aria-label="Fermer">&times;</button></div>'
        + '<div class="pcc-list">' + comparaison() + '</div></div>';
      return;
    }

    var list = (byFam[pickFam] || []).slice();
    Object.keys(pickFilters).forEach(function (k) {
      var v = pickFilters[k]; if (v === '' || v === undefined) return;
      list = list.filter(function (p) {
        var pv = attr(p, k);
        if (Array.isArray(pv)) return pv.map(String).indexOf(String(v)) > -1;
        return String(pv) === String(v);
      });
    });
    if (pickQuery) {
      var q = pickQuery.toLowerCase();
      list = list.filter(function (p) { return (p.titre + ' ' + p.marque).toLowerCase().indexOf(q) > -1; });
    }
    var enriched = list.map(function (p) {
      var b = candidateBlockers(pickFam, p, pickAdd ? 'add' : null);
      return { p: p, ko: b.length > 0, msg: b.map(function (x) { return x.message; }).join(' ') };
    });
    if (pickSort === 'prix') enriched.sort(function (a, b) { return a.p.prix - b.p.prix; });
    else if (pickSort === '-prix') enriched.sort(function (a, b) { return b.p.prix - a.p.prix; });
    else if (pickSort === 'perf') enriched.sort(function (a, b) { return (num(attr(b.p, 'perf_score')) || 0) - (num(attr(a.p, 'perf_score')) || 0); });
    else if (pickSort === 'marque') enriched.sort(function (a, b) { return String(a.p.marque).localeCompare(String(b.p.marque)); });
    enriched.sort(function (a, b) { return (a.ko ? 1 : 0) - (b.ko ? 1 : 0); });

    var okList = enriched.filter(function (e) { return !e.ko; });
    var okCount = okList.length;
    var moinsCher = okList.length ? okList.slice().sort(function (a, b) { return a.p.prix - b.p.prix; })[0].p.vid : null;
    var meilleur = null, bestR = -1;
    okList.forEach(function (e) {
      var s = num(attr(e.p, 'perf_score'));
      if (s === null || !e.p.prix) return;
      var r = s / (e.p.prix / 10000);
      if (r > bestR) { bestR = r; meilleur = e.p.vid; }
    });
    var current = items(pickFam).map(function (l) { return l.vid; });

    var rows = enriched.length ? enriched.map(function (e) {
      var p = e.p;
      var ks = (f.attributs_affiches && f.attributs_affiches.length) ? f.attributs_affiches : Object.keys(p.attrs).slice(0, 4);
      var sp = ks.map(function (k) {
        var v = attr(p, k);
        if (v === undefined) return null;
        return '<em>' + esc((LIB[k] || k) + ' : ' + fmtAttr(k, v)) + '</em>';
      }).filter(Boolean).join('');
      var badges = '';
      if (!e.ko && p.vid === moinsCher) badges += '<em style="background:rgba(37,194,106,.16);border-color:rgba(37,194,106,.35);color:#25c26a">Le moins cher compatible</em>';
      if (!e.ko && p.vid === meilleur && p.vid !== moinsCher) badges += '<em style="background:rgba(225,27,40,.16);border-color:rgba(225,27,40,.35);color:#ff3b48">Meilleur rapport perf/prix</em>';
      var inCmp = cmp.indexOf(p.vid) > -1;
      return '<div class="pcc-item' + (e.ko ? ' ko' : '') + (current.indexOf(p.vid) > -1 ? ' on' : '') + '">'
        + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '<div class="ph"></div>')
        + '<div class="inf"><div class="br">' + esc(p.marque) + '</div><div class="nm">' + esc(p.titre) + '</div>'
        + '<div class="sp">' + badges + sp + '</div>'
        + (e.ko ? '<div class="ko-msg">' + esc(e.msg) + '</div>' : '')
        + '</div><div class="rgt"><div class="pr">' + money(p.prix) + '</div>'
        + '<div class="dl">' + esc(attr(p, 'delai_appro') || '') + '</div>'
        + (e.ko ? '' : '<button class="pcc-btn pcc-btn--sm" data-choose="' + p.vid + '">' + (current.indexOf(p.vid) > -1 ? 'Selectionne' : 'Choisir') + '</button>'
            + '<button class="pcc-btn pcc-btn--ghost pcc-btn--sm" data-cmp="' + p.vid + '">' + (inCmp ? 'Retirer' : 'Comparer') + '</button>')
        + '</div></div>';
    }).join('') : '<div class="pcc-empty">Aucune reference ne correspond a ces criteres.</div>';

    var filtres = (f.attributs_filtres || []).map(function (k) {
      var vals = {};
      (byFam[pickFam] || []).forEach(function (p) {
        var v = attr(p, k); if (v === undefined) return;
        (Array.isArray(v) ? v : [v]).forEach(function (x) { vals[String(x)] = true; });
      });
      var keys = Object.keys(vals).sort(function (a, b) {
        var na = parseFloat(a), nb = parseFloat(b);
        if (!isNaN(na) && !isNaN(nb)) return na - nb;
        return a.localeCompare(b);
      });
      if (!keys.length) return '';
      return '<select data-filter="' + esc(k) + '"><option value="">' + esc(LIB[k] || k) + ' : tous</option>'
        + keys.map(function (v) {
          return '<option value="' + esc(v) + '"' + (pickFilters[k] === v ? ' selected' : '') + '>' + esc(fmtAttr(k, v === 'true' ? true : v === 'false' ? false : v)) + '</option>';
        }).join('') + '</select>';
    }).join('');

    var actifs = Object.keys(pickFilters).filter(function (k) { return pickFilters[k]; }).length;

    els.modal.innerHTML = '<div class="pcc-panel" role="dialog" aria-modal="true">'
      + '<div class="pcc-panel-hd"><div><h3>' + esc(f.libelle) + '</h3>'
      + '<p>' + okCount + ' compatible' + (okCount > 1 ? 's' : '') + ' sur ' + enriched.length + ' affichee' + (enriched.length > 1 ? 's' : '') + '</p></div>'
      + '<button class="pcc-close" data-close="1" aria-label="Fermer">&times;</button></div>'
      + '<div class="pcc-tools"><input type="search" data-search="1" placeholder="Rechercher une reference" value="' + esc(pickQuery) + '">'
      + filtres
      + '<select data-sort="1">'
      + '<option value="prix"' + (pickSort === 'prix' ? ' selected' : '') + '>Prix croissant</option>'
      + '<option value="-prix"' + (pickSort === '-prix' ? ' selected' : '') + '>Prix decroissant</option>'
      + '<option value="perf"' + (pickSort === 'perf' ? ' selected' : '') + '>Performance</option>'
      + '<option value="marque"' + (pickSort === 'marque' ? ' selected' : '') + '>Marque</option>'
      + '</select>'
      + (actifs ? '<button class="pcc-btn pcc-btn--soft pcc-btn--sm" data-rzfiltres="1">Reinitialiser</button>' : '')
      + (cmp.length >= 2 ? '<button class="pcc-btn pcc-btn--sm" data-vue="compare">Comparer les ' + cmp.length + '</button>' : '')
      + '</div>'
      + '<div class="pcc-list">' + rows + '</div></div>';
  }

  function choose(vid) {
    var p = prod(vid); if (!p) return;
    var f = fam(pickFam), max = f && f.qte_max ? f.qte_max : 1;
    var cur = items(pickFam).slice();
    if (pickAdd && cur.length < max) {
      var ex = cur.filter(function (l) { return l.vid === vid; })[0];
      if (ex) ex.qty = Math.min(max, ex.qty + 1); else cur.push({ vid: vid, qty: 1 });
      S.sel[pickFam] = cur;
    } else { S.sel[pickFam] = [{ vid: vid, qty: 1 }]; }
    closePicker(); render();
  }

  function swap(famCode, sens) {
    var cur = first(famCode); if (!cur) return;
    var liste = compatibles(famCode).sort(function (a, b) { return a.prix - b.prix; });
    var idx = -1;
    liste.forEach(function (p, i) { if (p.vid === cur.vid) idx = i; });
    var next = idx + sens;
    if (idx < 0 || next < 0 || next >= liste.length) return;
    S.sel[famCode] = [{ vid: liste[next].vid, qty: 1 }];
    render();
  }

  function applyPreset(handle) {
    var p = DATA.presets.filter(function (x) { return x.handle === handle; })[0];
    if (!p) return;
    S.univers = p.univers || 'gaming';
    S.mode = 'avance'; S.vue = 'postes'; S.sel = {};
    p.composants.forEach(function (vid) {
      var x = prod(vid); if (!x) return;
      var cur = S.sel[x.fam] || [];
      cur.push({ vid: vid, qty: 1 });
      S.sel[x.fam] = cur;
    });
    if (p.budget_cible) S.budget = p.budget_cible;
    defaultOptions();
    S.step = 2; render();
  }

  function defaultOptions() {
    DATA.options.forEach(function (o) { if (o.obligatoire) S.opts[o.code] = true; });
  }

  function addToCart(btn) {
    var ni = document.getElementById('pcc-nom');
    var nom = (ni && ni.value) || S.nom || 'PC sur mesure PhenixPC';
    var ref = refDevis();
    var cid = 'cfg-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var lines = [], ordre = 0;
    DATA.familles.forEach(function (f) {
      chosen(f.code).forEach(function (x) {
        ordre++;
        lines.push({ id: x.p.vid, quantity: x.qty, properties: { _config_id: cid, _config_ref: ref, _config_role: f.libelle, _config_ordre: ordre, Configuration: nom } });
      });
    });
    DATA.options.forEach(function (o) {
      if (S.opts[o.code] && o.variant_id) {
        ordre++;
        lines.push({ id: o.variant_id, quantity: 1, properties: { _config_id: cid, _config_ref: ref, _config_role: 'Option - ' + o.libelle, _config_ordre: ordre, Configuration: nom } });
      }
    });
    if (!lines.length) return;
    btn.disabled = true; btn.textContent = 'Ajout au panier...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Erreur panier');
        localStorage.removeItem('pcc_state');
        window.location.href = '/cart';
      })
      .catch(function (e) {
        btn.disabled = false; btn.textContent = 'Ajouter au panier';
        alert('Ajout au panier impossible : ' + e.message);
      });
  }

  function saveLocal() {
    try {
      localStorage.setItem('pcc_state', JSON.stringify({ u: S.univers, m: S.mode, s: S.step, v: S.vue, sel: S.sel, o: S.opts, b: S.budget, n: S.nom, p: S.profil, r: S.ref, t: Date.now() }));
    } catch (e) { }
  }
  function loadLocal() {
    try {
      var raw = localStorage.getItem('pcc_state'); if (!raw) return false;
      var j = JSON.parse(raw);
      if (!j || Date.now() - (j.t || 0) > 30 * 864e5) return false;
      S.univers = j.u; S.mode = j.m || 'avance'; S.step = j.s || 2; S.vue = j.v || 'postes';
      S.sel = j.sel || {}; S.opts = j.o || {}; S.budget = j.b || null; S.nom = j.n || '';
      S.profil = j.p || {}; S.ref = j.r || null;
      return true;
    } catch (e) { return false; }
  }
  function shareLink() {
    var payload = { u: S.univers, m: S.mode, sel: S.sel, o: S.opts, n: S.nom };
    var code = btoa(unescape(encodeURIComponent(JSON.stringify(payload)))).replace(/=+$/, '');
    var url = location.origin + location.pathname + '?config=' + encodeURIComponent(code);
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { alert('Lien copie :\n' + url); }, function () { prompt('Copiez ce lien :', url); });
    } else prompt('Copiez ce lien :', url);
  }
  function fromUrl() {
    var m = location.search.match(/[?&]config=([^&]+)/); if (!m) return false;
    try {
      var j = JSON.parse(decodeURIComponent(escape(atob(decodeURIComponent(m[1])))));
      S.univers = j.u || 'gaming'; S.mode = j.m || 'avance'; S.sel = j.sel || {};
      S.opts = j.o || {}; S.nom = j.n || ''; S.step = 2; S.vue = 'postes';
      return true;
    } catch (e) { return false; }
  }

  function bind() {
    els.app.querySelectorAll('[data-start]').forEach(function (b) {
      b.onclick = function () {
        S.univers = b.dataset.start; S.mode = b.dataset.mode; S.step = 1;
        S.vue = 'postes'; S.propos = null;
        if (!S.budget && UNIVERS[S.univers]) S.budget = UNIVERS[S.univers].budget;
        defaultOptions(); render();
      };
    });
    els.app.querySelectorAll('[data-generer]').forEach(function (b) {
      b.onclick = function () {
        var bi = document.getElementById('pcc-budget');
        if (bi && bi.value) S.budget = parseInt(bi.value, 10) || null;
        S.propos = genererPropositions();
        S.vue = 'propositions'; S.step = 2;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        render();
      };
    });
    els.app.querySelectorAll('[data-propos]').forEach(function (b) {
      b.onclick = function () {
        var c = S.propos[parseInt(b.dataset.propos, 10)];
        if (!c) return;
        S.sel = JSON.parse(JSON.stringify(c.sel));
        S.vue = 'postes'; S.step = 2;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        render();
      };
    });
    els.app.querySelectorAll('[data-niveau]').forEach(function (b) {
      b.onclick = function () {
        var parts = b.dataset.niveau.split('|');
        S.sel[parts[0]] = [{ vid: parseInt(parts[1], 10), qty: 1 }];
        render();
      };
    });
    els.app.querySelectorAll('[data-swap]').forEach(function (b) {
      b.onclick = function () {
        var parts = b.dataset.swap.split('|');
        swap(parts[0], parseInt(parts[1], 10));
      };
    });
    els.app.querySelectorAll('[data-next]').forEach(function (b) {
      b.onclick = function () {
        var bi = document.getElementById('pcc-budget');
        if (bi && bi.value) S.budget = parseInt(bi.value, 10) || null;
        var ni = document.getElementById('pcc-nom');
        if (ni) S.nom = ni.value;
        S.step = parseInt(b.dataset.next, 10);
        if (S.step === 2) S.vue = 'postes';
        window.scrollTo({ top: 0, behavior: 'smooth' });
        render();
      };
    });
    els.app.querySelectorAll('[data-goto]').forEach(function (li) {
      if (li.tagName === 'LI' && !li.classList.contains('clickable')) return;
      li.onclick = function () { S.step = parseInt(li.dataset.goto, 10); render(); };
    });
    els.app.querySelectorAll('[data-mode]').forEach(function (b) {
      if (b.dataset.start) return;
      b.onclick = function () {
        S.mode = b.dataset.mode;
        if (S.mode === 'avance') S.vue = 'postes';
        render();
      };
    });
    els.app.querySelectorAll('[data-pick]').forEach(function (b) { b.onclick = function () { openPicker(b.dataset.pick, false); }; });
    els.app.querySelectorAll('[data-add]').forEach(function (b) { b.onclick = function () { openPicker(b.dataset.add, true); }; });
    els.app.querySelectorAll('[data-clear]').forEach(function (b) { b.onclick = function () { delete S.sel[b.dataset.clear]; render(); }; });
    els.app.querySelectorAll('[data-help]').forEach(function (b) {
      b.onclick = function () { var t = document.getElementById('help-' + b.dataset.help); if (t) t.classList.toggle('pcc-hide'); };
    });
    els.app.querySelectorAll('[data-reset]').forEach(function (b) {
      b.onclick = function () {
        if (!confirm('Supprimer toute la configuration ?')) return;
        S.sel = {}; S.opts = {}; S.propos = null; S.ref = null; defaultOptions(); render();
      };
    });
    els.app.querySelectorAll('[data-preset]').forEach(function (b) { b.onclick = function () { applyPreset(b.dataset.preset); }; });
    els.app.querySelectorAll('[data-resume]').forEach(function (b) { b.onclick = function () { if (loadLocal()) render(); }; });
    els.app.querySelectorAll('[data-forget]').forEach(function (b) { b.onclick = function () { localStorage.removeItem('pcc_state'); render(); }; });
    els.app.querySelectorAll('[data-opt]').forEach(function (c) { c.onchange = function () { S.opts[c.dataset.opt] = c.checked; render(); }; });
    els.app.querySelectorAll('input[name^="q_"]').forEach(function (r) { r.onchange = function () { S.profil[r.name.slice(2)] = r.value; }; });
    els.app.querySelectorAll('[data-share]').forEach(function (b) { b.onclick = shareLink; });
    els.app.querySelectorAll('[data-print]').forEach(function (b) { b.onclick = function () { window.print(); }; });
    els.app.querySelectorAll('[data-cart]').forEach(function (b) { b.onclick = function () { addToCart(b); }; });
  }

  function bindModal() {
    els.modal.addEventListener('click', function (e) {
      if (e.target === els.modal || e.target.closest('[data-close]')) { closePicker(); return; }
      var vue = e.target.closest('[data-vue]');
      if (vue) { pickVue = vue.dataset.vue; renderPicker(); return; }
      var rz = e.target.closest('[data-rzfiltres]');
      if (rz) { pickFilters = {}; renderPicker(); return; }
      var cm = e.target.closest('[data-cmp]');
      if (cm) {
        var v = parseInt(cm.dataset.cmp, 10), i = cmp.indexOf(v);
        if (i > -1) cmp.splice(i, 1);
        else { if (cmp.length >= 3) cmp.shift(); cmp.push(v); }
        renderPicker();
        return;
      }
      var ch = e.target.closest('[data-choose]');
      if (ch) { choose(parseInt(ch.dataset.choose, 10)); }
    });
    els.modal.addEventListener('change', function (e) {
      var f = e.target.closest('[data-filter]');
      if (f) { pickFilters[f.dataset.filter] = f.value; renderPicker(); return; }
      if (e.target.dataset.sort) { pickSort = e.target.value; renderPicker(); }
    });
    els.modal.addEventListener('input', function (e) {
      if (e.target.type === 'search') {
        pickQuery = e.target.value;
        clearTimeout(els.modal._t);
        els.modal._t = setTimeout(function () {
          renderPicker();
          var ni = els.modal.querySelector('[data-search]');
          if (ni) { ni.focus(); ni.setSelectionRange(ni.value.length, ni.value.length); }
        }, 250);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !els.modal.hidden) closePicker(); });
  }

  function init(node) {
    root = node;
    els.app = root.querySelector('[data-pcc-app]');
    els.modal = root.querySelector('[data-pcc-modal]');
    els.bar = root.querySelector('[data-pcc-bar]');
    els.app.innerHTML = '<div class="pcc-loading"><div class="pcc-spin"></div>Chargement du catalogue...</div>';
    loadAll(root, function () {
      if (!DATA.familles.length) {
        els.app.innerHTML = '<div class="pcc-err-box"><strong>Configurateur non parametre.</strong> Aucune famille de composants active.</div>';
        return;
      }
      if (!DATA.produits.length) {
        els.app.innerHTML = '<div class="pcc-err-box"><strong>Aucun composant eligible.</strong> Ajoutez des entrees dans PhenixPC Configurator 0 Composants.</div>';
        return;
      }
      defaultOptions();
      if (!fromUrl()) S.step = 0;
      bindModal();
      render();
    }, function (err) {
      els.app.innerHTML = '<div class="pcc-err-box"><strong>Donnees indisponibles.</strong> Le flux du configurateur n a pas repondu (' + esc(err.message) + ').</div>';
    });
  }

  function boot() {
    document.querySelectorAll('[data-pcc-root]').forEach(function (n) {
      if (n.dataset.pccInit) return;
      n.dataset.pccInit = '1';
      init(n);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
